<div class="platform-comments-chat" [class.fullscreen]="isFullscreen" #platformCommentsChat>
  <ng-template
    #profilePictureTemplate
    let-username="username"
    let-width="width"
    let-height="height"
    let-fontSize="fontSize">
    <mtm-user-profile-picture
      [style.min-width]="'21px'"
      [width]="width"
      [height]="height"
      [username]="username"
      [fontSize]="fontSize" />
  </ng-template>
  <div class="d-flex flex-column comments-container w-100" [class.fullscreen]="isFullscreen">
    <conversation-interface
      class="d-flex flex-fill mt-2 mt-md-0"
      [annotationPlugin]="commentAnnotationPlugin"
      [profilePictureTemplate]="profilePictureTemplate"
      [instanceId]="instanceId"
      [isFullscreen]="isFullscreen"
      [readOnly]="false"
      [mediaType]="'platform'"
      [currentUser]="currentUsername"
      [viewMode]="viewMode"
      [entityName]="resolvedEntityName"
      [navigationRequest]="navigationRequest"
      (onSelectThread)="onSelectThread($event)"
      (onEditMessage)="onEditMessage($event)"
      (onUpdateEditMessage)="handleUpdateEditMessage($event)"
      (onShowChannelManager)="onShowChannelManager($event)"
      (onCloseChannelManager)="onCloseChannelManager()"
      (onSendOtherTypesMessage)="handleSendOtherTypesMessage($event)"
      #conversationInterface></conversation-interface>
  </div>
</div>
